<script lang="ts">
  import {createEventDispatcher} from 'svelte';
  import {isOptionLink, type DropdownButtonOption} from './types';
  import {clickOutside} from '@/actions/clickOutside';
  import {fade} from 'svelte/transition';

  export let disabled = false;
  export let options: DropdownButtonOption[] = [];
  export let variant: 'simple' | 'default' = 'default';

  const buttonClass = variant === 'simple' ? 'text-gray-400' : 'hoversermonbg bg-sermon-pink text-white';
  const buttonBorderClass =
    variant === 'simple'
      ? 'text-gray-400'
      : 'border-l border-sermon-pink text-white border-sermon-pink-600 bg-sermon-pink';

  const dispatch = createEventDispatcher<{
    click: void;
    optionClick: DropdownButtonOption;
  }>();

  let isOpen = false;
</script>

<div use:clickOutside={{callback: () => (isOpen = false)}} class="dropdown-container relative inline-flex">
  <!-- Primary action button -->
  <button
    on:click={() => dispatch('click')}
    {disabled}
    class="{disabled ? 'bg-zinc-400' : buttonClass}  
            rounded-l-md px-4 py-2 focus:z-10 focus:outline-none"
  >
    <slot />
  </button>

  <!-- Dropdown trigger button -->
  <button
    on:click={() => (isOpen = !isOpen)}
    {disabled}
    class="{disabled ? 'border-zinc-300 bg-zinc-400' : buttonBorderClass}  
            inline-flex items-center justify-center rounded-r-md px-2 py-2 focus:z-10 focus:outline-none"
  >
    <i class="fas fa-chevron-down text-sm" />
  </button>

  <!-- Dropdown menu -->
  {#if isOpen}
    <div
      class="absolute right-0 mt-2 w-max rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      style="top: 100%;"
      transition:fade={{duration: 150}}
    >
      <div class="py-1" role="menu">
        {#each options as option}
          {#if isOptionLink(option)}
            <a
              href={option.href}
              class="flex w-full items-center gap-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              role="menuitem"
            >
              {#if option.icon}
                <i class={option.icon} />
              {/if}
              {option.label}
            </a>
          {:else}
            <button
              on:click={() => {
                dispatch('optionClick', option);
                option.onClick?.();
              }}
              class=" flex w-full items-center gap-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              role="menuitem"
            >
              {#if option.icon}
                <i class={option.icon} />
              {/if}
              {option.label}
            </button>
          {/if}
        {/each}
      </div>
    </div>
  {/if}
</div>
